export default __webpack_public_path__ + "static/media/gestioneInfoClienti.5ee42fde.svg";